'use client';

import dynamic from 'next/dynamic';
import Sidebar from '@/components/Sidebar';
import { twMerge } from 'tailwind-merge';

// Lazy load PDF viewer to reduce main bundle size
const PdfView = dynamic(() => import('./components/PdfView'), {
  loading: () => <div className="h-96 bg-gray-100 animate-pulse rounded" />,
  ssr: false,
});

export default function PdfPage(props) {
  const { rightBanners, linkPages, websiteCode, slugDetail } = props;

  return (
    <div className="flex flex-col min-h-screen mb-3">
      <div className={twMerge('container mx-auto bg-white', slugDetail ? 'px-2 md:px-4 py-2' : '')}>
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Cột nội dung chính */}
          <section className="lg:w-3/4 ">
            <PdfView {...props} />
          </section>

          {/* Cột sidebar */}
          <section className="w-full lg:w-1/4">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </section>
        </div>
      </div>
    </div>
  );
}
